var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8893 13.4136V3.04473C12.8893 2.1916 12.1977 1.5 11.3446 1.5H8.73559C7.88245 1.5 7.19085 2.1916 7.19085 3.04473V13.4136C3.89333 14.5989 1.50757 17.7293 1.50757 21.4371C1.50757 25.1449 3.89333 28.2753 7.19085 29.4605V56.9553C7.19085 57.8084 7.88245 58.5 8.73559 58.5H11.3446C12.1977 58.5 12.8893 57.8084 12.8893 56.9553V29.4757C16.202 28.3057 18.603 25.1601 18.603 21.4523C18.603 17.7445 16.202 14.5837 12.8893 13.4136Z",
    fill: "#C32A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8416 30.5091V3.04473C32.8416 2.1916 32.15 1.5 31.2969 1.5H28.6879C27.8347 1.5 27.1431 2.1916 27.1431 3.04473V30.5091C23.8456 31.6943 21.4598 34.8247 21.4598 38.5325C21.4598 42.2403 23.8456 45.3707 27.1431 46.556V56.9553C27.1431 57.8084 27.8347 58.5 28.6879 58.5H31.2969C32.15 58.5 32.8416 57.8084 32.8416 56.9553V46.556C36.1543 45.3859 38.5553 42.2403 38.5553 38.5325C38.5553 34.8247 36.1543 31.6792 32.8416 30.5091Z",
    fill: "#1A5298"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4924 21.4371C58.4924 17.7293 56.0915 14.5837 52.7787 13.4136V3.04473C52.7787 2.1916 52.0871 1.5 51.234 1.5H48.625C47.7719 1.5 47.0803 2.1916 47.0803 3.04473V13.4136C43.7827 14.5989 41.397 17.7293 41.397 21.4371C41.397 25.1449 43.7827 28.2753 47.0803 29.4605V56.9553C47.0803 57.8084 47.7719 58.5 48.625 58.5H51.234C52.0871 58.5 52.7787 57.8084 52.7787 56.9553V29.4757C56.0915 28.2905 58.4924 25.1449 58.4924 21.4371Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.c06c6aaaa7e16e1159a5ede109861384.svg";
export { ForwardRef as ReactComponent };